const url ="https://shopsyncbackend-2.onrender.com";
// const url ="http://localhost:4000";
export default url;
